import { render, staticRenderFns } from "./header.vue?vue&type=template&id=ec7fde6c&scoped=true"
import script from "./header.vue?vue&type=script&lang=js"
export * from "./header.vue?vue&type=script&lang=js"
import style0 from "./header.vue?vue&type=style&index=0&id=ec7fde6c&prod&lang=scss&scoped=true"
import style1 from "./header.vue?vue&type=style&index=1&id=ec7fde6c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec7fde6c",
  null
  
)

export default component.exports